<template>
  <div class="pagination-wrap">
    <el-pagination
      background
      :layout="layoutConfig"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :page-size="pageSize"
      :page-sizes="[5, 10, 15, 30, 50, 100, 300, 1000, 3000]"
      :total="total"
      :current-page="firstPage"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "paginationVue",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    firstPage: {
      type: Number,
      default: 1,
    },
    layoutConfig: {
      type: String,
      default: "sizes, prev, pager, next, jumper",
    },
  },
  emits: ["currentChange", "sizeChange"],
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(pageNum) {
      this.$emit("currentChange", pageNum);
    },
    handleSizeChange(pageSize) {
      this.$emit("sizeChange", pageSize);
    },
  },
};
</script>
